<template>
<div class="post-body atb-flex">
  <div class="article-content">
    <div class="header">OEC绩效管理系统操作说明</div>
    <h1>一、谷歌浏览器下载安装</h1>
    <article>
        <p class="content">为保证系统运行稳定性，须使用谷歌浏览器。</p>
        <p class="little-title">安装方式：</p>
        <p class="content">
          任意浏览器复制登录网址：https://oec.autobio.com.cn/，点击进入登录界面，界面下方设置有谷歌浏览器下载链接，如图（一般推荐下载64位）：
        </p>
    </article>
    <h1>二、登录及密码管理</h1>
      <p class="little-title">1、登录</p>
      <p class="content">复制网址：https://oec.autobio.com.cn/，至谷歌浏览器网址搜索框中，点击进入登录界面，使用云之家扫描登录。</p>
      <p class="little-title">2、密码管理</p>
      <p class="content">登录后，点击右侧“头像-设置密码”修改密码，修改后可使用账号密码进行登录（账号为工号，密码为OEC系统密码）；</p>
      <p class="little-title">3、密码忘记</p>
      <p class="content">可用云之家扫码登录后点击“头像”，重置密码即可。</p>
      <p class="little-title">4、密码设置注意事项</p>
      <p class="content">密码中必须包含数字、字母，并且不能少于8位；</p>
    <h1>三、系统界面和功能介绍</h1>
      <p class="content">OEC绩效管理系统分为：首页、通知中心、个人工作台、新增工作管理、管理工作台。</p>
      <p class="little-title">1、首页</p>
      <p class="content">常用功能快捷入口、消息快捷入口、未完成工作展示；</p>
      <p class="little-title">2、通知中心</p>
      <p class="content">各类消息、新增工作信息等消息提醒、阅读；</p>
      <p class="little-title">3、个人工作台</p>
      <p class="content">年计划、月计划、周计划、日计划的填写，工作进度管理，个人OEC结果查询，工作撤回；</p>
      <p class="little-title">4、新增工作</p>
      <p class="content">发布新增年度工作，新增月周日工作到指定人，历史新增工作查询；</p>
      <p class="little-title">5、管理工作台</p>
      <p class="content">OEC结果申报，OEC结果比例分析，历史OEC结果查询，管理人员执行表格查看、导出等；</p>
    <h1>四、操作指引</h1>
    <h2>（一）计划填写：请先填写计划部分并通过审批</h2>
    <h1>3</h1>
    
  </div>
  <div class="catalog-card" v-if="Object.keys(titles).length > 0">
    <div class="catalog-card-header">
      <div>
        <span>目录</span>
      </div>
    </div>

    <div class="catalog-content">
      <div
        v-for="title in titles"
        :key="title.id"
        @click="scrollToView(title.scrollTop)"
        :class="['catalog-item', currentTitle.id == title.id ? 'active' : 'not-active']"
        :style="{ marginLeft: title.level * 20 + 'px' }"
        :title="title.rawName"
      >
        {{ title.name }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from "lodash";
export default {
  name: 'KilaKilaCatalog',
  data() {
    return {
      titles: '',
      currentTitle: {
        id: ''
      },
      progress: 0,
      container: '.post-body .article-content'
    };
  },
  props: {
    
  },
  mounted(){
    this.getTitles();
    document.querySelector('.atb-content-tabs').addEventListener("scroll", this.handleScroll);
    
  },
  methods: {
    getTitles() {
      let titles = [];
      let levels = ['h1', 'h2', 'h3'];

      let articleElement = document.querySelector(this.container);
      if (!articleElement) {
        return titles;
      }

      let elements = Array.from(articleElement.querySelectorAll('*'));

      // 调整标签等级
      let tagNames = new Set(elements.map((el) => el.tagName.toLowerCase()));
      for (let i = levels.length - 1; i >= 0; i--) {
        if (!tagNames.has(levels[i])) {
          levels.splice(i, 1);
        }
      }

      let serialNumbers = levels.map(() => 0);
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        let tagName = element.tagName.toLowerCase();
        let level = levels.indexOf(tagName);
        if (level == -1) continue;

        let id = tagName + '-' + element.innerText + '-' + i;
        let node = {
          id,
          level,
          parent: null,
          children: [],
          rawName: element.innerText,
          scrollTop: element.offsetTop ,
        };

        if (titles.length > 0) {
          let lastNode = _.at(titles, -1);

          // 遇到子标题
          if (lastNode.level < node.level) {
            node.parent = lastNode;
            lastNode.children.push(node);
          }
          // 遇到上一级标题
          else if (lastNode.level > node.level) {
            serialNumbers.fill(0, level + 1);
            let parent = lastNode.parent;
            while (parent) {
              if (parent.level < node.level) {
                parent.children.push(node);
                node.parent = parent;
                break;
              }
              parent = parent.parent;
            }
          }
          // 遇到平级
          else if (lastNode.parent) {
            node.parent = lastNode.parent;
            lastNode.parent.children.push(node);
          }
        }

        serialNumbers[level] += 1;
        // let serialNumber = serialNumbers.slice(0, level + 1).join('.');

        node.isVisible = node.parent == null;
        node.name = element.innerText;
        titles.push(node);
      }

      this.titles = titles;
    },
    scrollToView(scrollTop) {
      document.querySelector('.atb-content-tabs').scrollTo({ top: scrollTop, behavior: 'smooth' });
    },
    setChildrenVisible(title, isVisible) {
      for (const child of title.children) {
        child.isVisible = isVisible;
      }
    },
    handleScroll() {

      let visibleTitles = [];
      console.log(document.querySelector('.atb-content-tabs').scrollTop);
      for (let i = this.titles.length - 1; i >= 0; i--) {
        const title = this.titles[i];
        if (title.scrollTop <= document.querySelector('.atb-content-tabs').scrollTop) {
          if (this.currentTitle.id === title.id) return;

          Object.assign(this.currentTitle, title);

          // 展开节点
          this.setChildrenVisible(title, true);
          visibleTitles.push(title);

          // 展开父节点
          let parent = title.parent;
          while (parent) {
            this.setChildrenVisible(parent, true);
            visibleTitles.push(parent);
            parent = parent.parent;
          }

          // 折叠其余节点
          for (const t of this.titles) {
            if (!visibleTitles.includes(t)) {
              this.setChildrenVisible(t, false);
            }
          }

          return;
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.post-body {
  position: relative;
  padding: 20px 20px 0 20px;
  background: #fff;
  border-radius: 20px;
  .article-content{
    width: 75%;
    padding: 0 20px;
    .header{
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      padding: 40px 0;
    }
    h1{
      font-size: 24px;
      font-weight: bold;
      margin: 20px 0;
    }
    .little-title{
      padding: 10px 0;
    }
    .content{
      font-size: 16px;
      padding: 10px 0;
    }
  }
}
.catalog-card {
  width: 450px;
  right: 20px;
  height: 100%;
  position: fixed;
  padding: 20px 24px;
  margin-top: 25px;
  box-sizing: border-box;
}

.catalog-card-header {
  text-align: left;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span{
    font-size: 20px;
    font-weight: bold;
    color: #4c4948;
  }
}

.catalog-icon {
  font-size: 18px;
  margin-right: 10px;
  color: dodgerblue;
}

.progress {
  color: #a9a9a9;
  font-style: italic;
  font-size: 140%;
}

.catalog-content {
  max-height: calc(100vh - 120px);
  overflow: auto;
  margin-right: -24px;
  padding-right: 20px;
}

.catalog-item {
  color: #666261;
  margin: 5px 0;
  line-height: 28px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: 14px;
  padding: 2px 6px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  &:hover {
    color: rgb(34, 182, 161);
  }
}
.active {
  color: rgb(34, 182, 161);
}
</style>
